var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{attrs:{"default-country-code":_vm.$props.country,"translations":_vm.translations[_vm.$props.lang]},on:{"update":_vm.updatePhone},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }